export enum UploadFileStatus {
  NOT_STARTED = 'NOT_STARTED',
  UPLOADING = 'UPLOADING',
  ERROR = 'ERROR',
  DONE = 'DONE'
}